import { Check, Close } from "@mui/icons-material";
import { Divider, List, ListItem, Typography } from "@mui/material";
import { alpha, Grid } from "@mui/system";

export const KdappontAiTraining = () => {
  return (
    <Grid container spacing={5}>
      <Grid size={6} justifyContent="space-between">
        <Typography variant="h4">Hoe schrijf je prompts?</Typography>

        <List
          sx={{
            fontSize: "1.8em",
            textAlign: "center",
          }}
        >
          <ListItem sx={{ fontWeight: "bold" }}>
            - Communiceer in "Structuur"
          </ListItem>

          <ListItem
            sx={(theme) => ({
              background: alpha(theme.palette.error.light, 0.3),
            })}
          >
            <Close sx={{ marginRight: 2 }} /> Maak een website met een
            linkerkant, rechterkant en middenstuk. Doe een blauw blokje in de
            header. Gebruik de kleuren uit mijn screenshot.
          </ListItem>

          <ListItem
            sx={(theme) => ({
              background: alpha(theme.palette.success.light, 0.3),
            })}
          >
            <Check sx={{ marginRight: 2 }} /> Maak een website die bestaat uit 3
            kolommen. <br /> Kolom één in de kleur #AAA, Kolom twee in de kleur
            #BBB en kolom 3 in de kleur #CCC. De middelste kolom moet bestaan
            uit 2 rijen. De bovenstenste daarvan fungeert als &lt;header&gt;.
            Splits die vervolgens weer in 2 kolommen, waarvan de rechterkolom
            een blauwe achtergrondkleur, #2730e1, krijgt.
          </ListItem>

          <ListItem sx={{ fontWeight: "bold" }}>- Bewaar je prompts!</ListItem>
          <ListItem sx={{ pl: 5 }}>Op het examen is dit verplicht!</ListItem>
          <ListItem sx={{ fontWeight: "bold" }}>
            - Klopt je basis niet?
          </ListItem>
          <ListItem sx={{ pl: 5 }}>
            Soms is het beter om opnieuw te beginnen
          </ListItem>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h4">Zelf kunnen aanpassen</Typography>

          <ListItem>
            Je moet handmatig wijzigingen kunnen doen in de code, zonder AI. Dit
            is een verplicht onderdeel van het examen.
          </ListItem>
        </List>
      </Grid>
      <Grid size={6}>
        <Typography variant="h4">Voorbeeld prompt</Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: "left",
            fontSize: "1.2em",
            border: "3px dotted #ccc",
            borderRadius: 1,
            p: 2,
          }}
        >
          Hé Chat,
          <br /> <br /> Ik wil graag dat je een website voor mij genereert.
          <br />
          <br /> Dit zijn de eisen:
          <br />
          <br /> - Gebruik altijd moderne technieken. Denk aan HTML5 tags, maar
          ook de laatst mogelijk technieken in CSS.
          <br /> - De body moet een rood kleurverloop bevatten
          <br /> - In het midden wil ik de website gaan opbouwen. Deze container
          is 1200px en moet gecentreerd zijn.
          <br />- De website bestaat uit een &lt;header&gt;, op de volgende
          manier: Een linkerkolom, bestaand uit weer 2 rijen. Rij 1 groen. Rij 2
          lichtgroen. Plaats in deze 2e rij ook meteen een een &lt;nav&gt;
          element.
          <br /> De rechterkolom moet blauw zijn.
          <br />
          De verhouding tussen de header kolommen is 80/20
          <br /> - Het volgende onderdeel in de &lt;main&gt;. Deze main beslaat
          de volledige breedte. En de kleur moet paarsig zijn.
          <br />- Als laatste verwacht ik een &lt;footer&gt; element. Deze moet
          ook volledig breed zijn. De kleur is zachtroze, ook met een
          kleurverloop.
          <br />
          <br />
          Extra vereisten: <br />
          Binnen de &lt;main&gt; wil ik 6 artikelen. Tekstkleur zwart. Deze
          artikelen moeten verdeeld worden over 2 kolommen. Dus 3 links, 3
          rechts. <br />
          Zet er trouwens eerst nog een H1 boven, met de tekst "Welkom op mijn
          Lorem Ipsum pagina". <br />
          <br /> Kun je de HTML en CSS hier apart voor genereren?
        </Typography>
      </Grid>
    </Grid>
  );
};
